/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { RoleService } from 'app/core/services/role/role.service';
import { Router, RouterOutlet } from "@angular/router";
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [ 
		HeaderComponent,
		FooterComponent,
		RouterOutlet
	],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})

export class HomeComponent implements OnInit {
  
	public currentRole: string = '';

	private accessibleRoutes = [
		{ path: 'administration', roles: ['ds-catalog-administrator'] },
		{ path: 'catalog', roles: ['ds-catalog-administrator', 'ds-catalog-user'] },
	];

	constructor(
		private roleService: RoleService,
		private router: Router
	) {}

	ngOnInit() {
		this.roleService.currentRole$.subscribe(role => {
			this.currentRole = role;
			this.router.navigate(['home', 'role'], { queryParams: { reload: new Date().getTime() } });
		});
	}

	public redirectToFirstAccessibleRoute(): void {
		const firstAccessibleRoute = this.accessibleRoutes.find(route =>
			route.roles.some(role => this.currentRole === role)
		);
		if (firstAccessibleRoute) {
			this.router.navigate([`home/${firstAccessibleRoute.path}`], { queryParams: { reload: new Date().getTime() } });
		} else {
			this.router.navigate(['access-denied']);
		}
	}

}
